module.exports = __webpack_public_path__ + "media/images/company/company_03_01-f0188bc096ae0c5583fa2522add016d4.jpg";